import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Table, Pagination, DatePicker, Button, Modal, Tooltip, Input, Select } from 'components';
import { CleanIcon, AddIcon, DeleteIcon, EditIcon } from 'assets/icons';
import { CategoryService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';
import { Globals, Constants, Socket, SocketEvents, checkPermission, Permissions } from 'utils';

const INITIAL_STATE = {
	search: '',
	status: ''
}

class Categories extends React.Component<any> {

	timer: any = undefined;

	state = {
		data: [],
		page: 1,
		last_page: 1,
		header: [
			'Fecha',
			'Nombre',
			'Imagen',
		],
		form: INITIAL_STATE,
		visible: false,
		item: null,
		visible_address: false,
		visible_rate: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Categorías',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await CategoryService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.categories.rows,
			last_page: res.categories.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		}, () => this.load(true));
	}

	change = (e: any, callback = () => { }) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		}, callback);
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		}, () => this.load(true));
	}

	onCloseRate = () => {
		this.setState({
			visible_rate: false,
			item: null
		}, () => this.load(true));
	}

	onCloseAddress = () => {
		this.setState({
			visible_address: false,
			item: null
		}, () => this.load(true));
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar la categoría?', async () => {
			await CategoryService.admin.delete({
				id: item.id
			});
			this.load(true);
		});
	}

	suspend = async (item: any) => {
		Globals.confirm(`¿Desea cambiar el estatus de la categoría a ${item.status == Constants.USER_STATUS.ACTIVE ? 'Suspendido' : 'Activo'}?`, async () => {
			await CategoryService.admin.suspend({
				id: item.id
			});
			this.load(true);
		});
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	viewRate = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_rate: true,
			item
		});
	}

	viewAddress = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_address: true,
			item
		});
	}

	render() {
		const { visible, visible_address, visible_rate } = this.state;

		return (
			<div id="admin-categories">
				<div id="admin-register-clinic">
					<Modal
						className="modal-create-clinic"
						visible={visible}
						withoutClose={true}
						onClose={() => this.onClose()}
					>
						<ModalCreate
							item={this.state.item}
							onClose={() => this.onClose()} />
					</Modal>

					<div className="row row-filter mx-auto" style={{ width: 680, alignItems: 'center' }}>
						<div className="col-md-6">
							<Input
								value={this.state.form.search}
								name="search"
								label="Buscar por nombre"
								placeholder="Buscar"
								className="input-table"
								onChange={(e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.load(true);
									}, 1000);
									this.change(e);
								}} />
						</div>
						{/* <div className="col-md-4">
							<Select
								label="Estatus"
								name="status"
								onChange={(e: any) => this.change(e, () => {
									this.load(true);
								})}
								value={this.state.form.status}
								options={[
									{ value: Constants.USER_STATUS.ACTIVE.toString(), label: 'Activos' },
									{ value: Constants.USER_STATUS.INACTIVE.toString(), label: 'Suspendidos' }
								]} />
						</div> */}
						<div className="col-md-4">
							{
								this.state.form != INITIAL_STATE && (
									<Button className="btn-clean" onClick={this.reset}>
										Limpiar
									</Button>
								)
							}
						</div>
					</div>

					<div className="categories-table">
						{/* <Table title="Categorías" data={this.state.data.length} header={this.state.header} rightAlign={[7]} titleRight={
							<React.Fragment>
								{
									checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
										<Button className="btn-add" onClick={() => this.add()}>
											<img src={AddIcon} />
											Nuevo
										</Button>
									)
								}
							</React.Fragment>
						}>
							{this.state.data.map((i: any, index: number) => {
								return (
									<tr key={index}>
										<td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
										<td>{i.name}</td>
										<td> 
											<img src={ Constants.BASE_STORAGE + i.image } />
										</td>
										<td className="vertical-center text-right">
											{
												checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
													<Tooltip title="Editar">
														<a className="link-icon" href="#" onClick={(e: any) => this.edit(e, i)}>
															<img src={EditIcon} />
														</a>
													</Tooltip>
												)
											}
											{
												checkPermission(Constants.MODULES.REGISTER, 'delete', this.props.user) && (
													<Tooltip title="Eliminar">
														<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
															<img src={DeleteIcon} />
														</a>
													</Tooltip>
												)
											}
											{
												checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
													<Tooltip title={i.status == Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}>
														<Button className={`btn-suspend ${i.status == Constants.USER_STATUS.ACTIVE ? '' : 'green'}`} onClick={() => this.suspend(i)}>
															{i.status == Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}
														</Button>
													</Tooltip>
												)
											}
										</td>
									</tr>
								)
							})} */}

						<div className="table-header">
							<p>Categorías registradas</p>
							{
								checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
									<Button className="btn-add" onClick={() => this.add()}>
										<img src={AddIcon} />
										Nueva categoría
									</Button>
								)
							}
						</div>

						{this.state.data.map((i: any, index: number) => {
							return (
								<div key={index} className="table-item">
									<div className="item-details">
										<div className="img-wrapper">
											<img src={ Constants.BASE_STORAGE + i.image } />
										</div>
										<p>{i.name}</p>
									</div>
									<div className="item-actions">
										{
											checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
												<Tooltip title="Editar">
													<a className="link-icon" href="#" onClick={(e: any) => this.edit(e, i)}>
														<img src={EditIcon} />
													</a>
												</Tooltip>
											)
										}
										{
											checkPermission(Constants.MODULES.REGISTER, 'delete', this.props.user) && (
												<Tooltip title="Eliminar">
													<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
														<img src={DeleteIcon} />
													</a>
												</Tooltip>
											)
										}
										{/* {
											checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
												<Tooltip title={i.status == Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}>
													<Button className={`btn-suspend ${i.status == Constants.USER_STATUS.ACTIVE ? '' : 'green'}`} onClick={() => this.suspend(i)}>
														{i.status == Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}
													</Button>
												</Tooltip>
											)
										} */}
									</div>
								</div>
							)
						})}
					</div>

					<Pagination
						pages={this.state.last_page}
						active={this.state.page}
						onChange={async (page: number) => {
							await this.setState({
								page: page
							});
							this.load();
						}} />
				</div>
			</div>

		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Categories);